var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 5.63275C16.0976 5.25924 16.0976 4.65365 15.7071 4.28014C15.3166 3.90662 14.6834 3.90662 14.2929 4.28014L8.29289 11.2687C7.90237 11.6422 7.90237 12.2478 8.29289 12.6213L14.2929 19.7199C14.6834 20.0934 15.3166 20.0934 15.7071 19.7199C16.0976 19.3463 16.0976 18.7408 15.7071 18.3672L10.4142 11.945L15.7071 5.63275Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft1);
export default __webpack_public_path__ + "static/media/chevron-left-1.33e6632a66cc143e30eca2b23452148e.svg";
export { ForwardRef as ReactComponent };